<template>
  <div>
    <!-- 消费统计明细开始 -->

    <el-dialog :close-on-click-modal="false"
      title="消费统计明细"
      :visible.sync="infoDialogVisible"
      :before-close="infoHandleClose"
      width="68.8%"
      center
      top="15vh"
    >
      <el-divider></el-divider>
      <el-row class="conentRow">
        <el-input placeholder="请输入订单号" v-model="data1.ordernumber"></el-input>
        <span style="display: flex;
    align-items: center;margin:0 10px 20px 10px;">选择日期</span>
         <el-date-picker
          v-model="data1.date"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
        <el-select v-model="data1.productid" clearable placeholder="全部商品">
          <el-option
            v-for="item in options"
            :key="item.ProductID"
            :label="item.ProductName"
            :value="item.ProductID"
          ></el-option>
        </el-select>
        <el-button class="conentBtn" type="primary" @click="Btns('1')">查询</el-button>
        <el-button class="conentBtn2" type="primary" @click="BtnsDcXf">导出报表</el-button>
      </el-row>
      <el-table
        :data="tableData"
        :header-cell-style="tableHeaderColor"
        :cell-style="cellStyle"
        key="five"
        style="width: 100%"
      >
        <el-table-column label="序号" type="index"></el-table-column>
        <el-table-column prop="Name" label="景区名称"></el-table-column>
        <el-table-column prop="OrdernNmber" label="订单号"></el-table-column>
        <el-table-column prop="CountPrice" label="金额"></el-table-column>
        <el-table-column prop="Use" label="数量"></el-table-column>
        <el-table-column prop="ProductName" label="产品名称"></el-table-column>
        <el-table-column prop="UseTime" label="验票时间"></el-table-column>
      </el-table>
      <!-- 分页开始 -->
      <div class="pagination">
        <span class="demonstration">共{{data1.tot}}条记录，</span>
        <span class="demonstration">当前显示第{{data1.page}}页</span>
        <el-pagination background layout="prev, pager, next" :total="data1.tot" :current-page="data1.page" @current-change="current1"></el-pagination>
      </div>
      <!-- 分页结束 -->
      <!-- 消费统计明细结束 -->
    </el-dialog>
    <!-- 退票统计明细开始 -->

    <el-dialog :close-on-click-modal="false"
      title="退票统计明细"
      :visible.sync="detailTickDialogVisible"
      :before-close="detailTickHandleClose"
      width="68.8%"
      center
      top="15vh"
    >
      <el-divider></el-divider>
      <el-row class="conentRow">
        <el-input placeholder="请输入订单号" v-model="data2.ordernumber"></el-input>
        <span style="display: flex;
    align-items: center;margin:0 10px 20px 10px;">选择日期</span>
        <el-date-picker
          v-model="data2.date"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
        <el-select v-model="data2.productid" clearable placeholder="全部商品">
          <el-option
            v-for="item in options"
            :key="item.ProductID"
            :label="item.ProductName"
            :value="item.ProductID"
          ></el-option>
        </el-select>
        <el-button class="conentBtn" type="primary" @click="Btns('2')">查询</el-button>
        <el-button class="conentBtn2" type="primary" @click="BtnsDc">导出报表</el-button>
      </el-row>
      <el-table
        :data="tableData"
        :header-cell-style="tableHeaderColor"
        :cell-style="cellStyle"
        key="five"
        style="width: 100%"
      >
        <el-table-column label="序号" type="index"></el-table-column>
        <el-table-column prop="Name" label="景区名称"></el-table-column>
        <el-table-column prop="OrdernNmber" label="订单号"></el-table-column>
        <el-table-column prop="CountPrice" label="退款金额"></el-table-column>
        <el-table-column prop="Use" label="数量"></el-table-column>
        <el-table-column prop="ProductName" label="产品名称"></el-table-column>
        <el-table-column prop="UseTime" label="退票时间"></el-table-column>
      </el-table>
      <!-- 分页开始 -->
      <div class="pagination">
        <span class="demonstration">共{{data2.tot}}条记录，</span>
        <span class="demonstration">当前显示第{{data2.page}}页</span>
        <el-pagination background layout="prev, pager, next" :total="data2.tot" :current-page="data2.page"  @current-change="current2"></el-pagination>
      </div>
      <!-- 分页结束 -->
      <!-- 退票统计明细结束 -->
    </el-dialog>
  </div>
</template>

<script>

import { getDistributorTPRecord ,getDistributorTPRecordExport,getDistributorXFRecord,getDistributorXFRecordExport,getProductDistributorList} from '@/request/distributor.js'
import {Message} from 'element-ui'
export default {
  data() {
    return {
      infoDialogVisible: false, // 消费统计明细
      detailTickDialogVisible: false, // 消费统计明细
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      value: "",
      options: [
      ],
      tableData: [
      ],
      data2:{
        token:window.sessionStorage.getItem('Token'),
        date:'',
        productid:'',
        ordernumber:'',
        page_size:8,
        page:1,
        tot:1
      },
      valueTime:'',
      data1:{
        token:window.sessionStorage.getItem('Token'),
        date:'',
        productid:'',
        ordernumber:'',
        page_size:8,
        page:1,
        tot:1
      }
    };
  },
  created(){
   
    this.getPro()
  },
  methods: {
    // 全部商品 
    getPro(){
      let data = {
        token:window.sessionStorage.getItem('Token'),
        page_size:99,
        page:1,
      }
      getProductDistributorList(data).then(res=>{
        console.log(res)
        if(res.data.status=='ok'){
          this.options = res.data.result.data
        }
      })
    },
    
    // 退票统计明细
    detailTick(row) {
        this.detailTickDialogVisible=true
        var newDate=/\d{4}-\d{1,2}-\d{1,2}/g.exec(row.UseTime)
        this.data2.date = [newDate + ' 00:00:00',newDate + ' 23:59:59']
        if(this.data2.date){
          this.data2.start_time = this.data2.date[0] 
          this.data2.end_time = this.data2.date[1] 
        }else{
          this.data2.start_time = ''
          this.data2.end_time = ''
        }
        this.getlist2()
    },
    getlist2(){
      if(this.data2.date){
        this.data2.start_time = this.data2.date[0]
        this.data2.end_time = this.data2.date[1] 
      }else{
        this.data2.start_time = ''
        this.data2.end_time = ''
      }
      getDistributorTPRecord(this.data2).then(res=>{
          if(res.data.status=='ok'){
            this.tableData = res.data.result.data
            this.data2.tot = res.data.result.total
          }
        })
    },
    current2(e){
      this.data2.page = e
      this.getlist2()
    },
    current1(e){
      this.data1.page = e
      this.getlist1()
    },
    Btns(i){
      if(i=='2'){
        if(!this.data2.date){
          Message.error('时间为空')
          return false
        }
        this.data2.page = 1
        this.getlist2()
      }else{
        if(!this.data1.date){
          Message.error('时间为空')
          return false
        }
        this.data1.page = 1
        this.getlist1()
      }
    },
    BtnsDc(){
      if(!this.data2.date){
        Message.error('请选择时间')
      }
      let data = {
        token:window.sessionStorage.getItem('Token'),
        start_time:this.data2.date[0],
        end_time:this.data2.date[1],
        date:this.data2.date,
        ordernumber:this.data2.ordernumber
      }
      getDistributorTPRecordExport(data).then(res=>{
        if(res.data.status=='ok'){
          const newUrl = res.data.result;
            const a = document.createElement("a");
            a.href = newUrl;
            a.download = '导出列表';
            a.target = "_blank";
            a.click();
        }
      })
    },
    BtnsDcXf(){
      if(!this.data1.date){
        Message.error('请选择时间')
      }
      let data = {
        token:window.sessionStorage.getItem('Token'),
        start_time:this.data1.date[0],
        end_time:this.data1.date[1],
        date:this.data1.date,
        ordernumber:this.data1.ordernumber
      }
      getDistributorXFRecordExport(data).then(res=>{
        if(res.data.status=='ok'){
            const newUrl = res.data.result;
            const a = document.createElement("a");
            a.href = newUrl;
            a.download = '导出列表';
            a.target = "_blank";
            a.click();
        }
      })
    },
    // 退票统计明细X
    detailTickHandleClose() {
        this.detailTickDialogVisible=false
        this.$emit('TPRecordClose')
    },
    // 消费统计明细
    Detail(row) {
        this.infoDialogVisible = true;
        var newDate=/\d{4}-\d{1,2}-\d{1,2}/g.exec(row.UseTime)
        this.data1.date = [ newDate + ' 00:00:00', newDate + ' 23:59:59']
        // 
        if(this.data1.date){
          this.data1.start_time = this.data1.date[0]
          this.data1.end_time = this.data1.date[1] 
        }else{
          this.data1.start_time = ''
          this.data1.end_time = ''
        }
        this.getlist1()
    },
    getlist1(){
      if(this.data1.date){
        this.data1.start_time = this.data1.date[0] 
        this.data1.end_time = this.data1.date[1]
      }else{
        this.data1.start_time = ''
        this.data1.end_time = ''
      }
      getDistributorXFRecord(this.data1).then(res=>{
        if(res.data.status=='ok'){
          this.tableData = res.data.result.data
          this.data1.tot = res.data.result.total
        }
      })
    },
    // 消费统计明细X
    infoHandleClose() {
      this.infoDialogVisible = false;
      this.$emit('XFRecordClose')
    },
    // 表头设置
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex
      });
    }
  }
};
</script>

<style lang='less' scoped>
/deep/.el-dialog{
  min-width: 400px;
}
.conentRow {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  // margin-bottom: 20px;
  .el-date-editor {
    margin-right: 20px;
    margin-bottom: 20px;
  }
  .el-input {
    width: 250px;
    margin-right: 20px;
    margin-bottom: 20px;
  }
  .el-select {
    width: 220px;
    margin-right: 20px;
    margin-bottom: 20px;
  }
  .conentBtn {
    width: 100px;
    background: #246deb;
    border-radius: 4px;
    margin-bottom: 20px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    border: none;
    color: #ffffff;
    border: none;
    margin-right: 10px;
  }
  .conentBtn2 {
    margin-bottom: 20px;
    width: 100px;
    background: #ffffff;
    border: 1px solid #246deb;
    border-radius: 4px;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #246deb;
    box-sizing: border-box;
  }
}
/deep/.el-dialog__header {
  height: 60px;
  line-height: 60px;
  padding: 0;
}

/deep/.el-dialog__body {
  padding: 0px 20px 20px;
}

// 弹框标题设置
/deep/.el-dialog__title {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

/deep/.el-icon-close {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  color: #000000;
}
/deep/.el-dialog__headerbtn {
  position: absolute;
  top: 5px;
  right: 20px;
  padding: 0;
  background: 0 0;
  border: none;
  outline: 0;
  cursor: pointer;
  font-size: 16px;
}

// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0 0 20px 0;
}
// 分页
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin: 20px auto 0px;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}

/deep/.el-pagination.is-background .el-pager li {
  margin: 0 5px;
  color: #000000;
  background: #ffffff;
  border: 1px solid #e5e5ea;
  border-radius: 2px;
  min-width: 32px;
}
/deep/.el-pager li {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  padding: 0 4px;
  background: #fff;
  min-width: 32px;
  height: 32px;
  line-height: 32px;
  box-sizing: border-box;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border: 1px solid #246deb;
  color: #246deb;
  background: white;
}

/deep/.el-pagination.is-background .btn-prev {
  color: #c0c4cc;
  height: 32px;
  min-width: 32px;
  background: white;
  border: 1px solid #e5e5ea;
}
/deep/.pagination .btn-prev .el-icon {
  display: block;
  font-size: 14px;
  font-weight: 700;
}

/deep/.el-pagination.is-background .btn-next {
  margin: 0 5px;
  background-color: white;
  color: #606266;
  min-width: 32px;
  height: 32px;
  border-radius: 2px;
  border: 1px solid #e5e5ea;
}
</style>